import pmedia from '../../assets/images/polarismedia_logo_neg.svg';

import '../../assets/scss/footer.scss';

const Footer = () => {
	return (
		<div className='footer'>
			<div className='container flex-column'>
				<div className='logo'>
					<img src={pmedia} alt='Adresseavisen logo' />
				</div>
			</div>
		</div>
	);
};

export default Footer;
